// extracted by mini-css-extract-plugin
export default {"container":"resend-otp_container__z89iI","resend-otp-msg":"resend-otp_resend-otp-msg__oTeXa"};